import request from './request'

// 用户收藏岗位
export function addFavoriteJob(data) {
  return request({
    url: '/api/job/favorite/add',
    method: 'post',
    data
  })
}

// 取消收藏
export function cancelFavoriteJob(data) {
  return request({
    url: '/api/job/favorite/cancel',
    method: 'post',
    data
  })
}

//检查是否已收藏

export function checkFavoriteStatus(jobId) {
  return request({
    url: `/api/job/favorite/check/${jobId}`,
    method: 'get'
  })
}

//获取收藏数量
export function getFavoriteCount() {
  return request({
    url: '/api/job/favorite/count',
    method: 'get'
  })
}

//获取收藏岗位列表
export function getFavoriteJobList(params) {
  return request({
    url: '/api/job/favorite/list',
    method: 'get',
    params
  })
}

// 求职期望相关接口

// 删除求职期望
export function deleteJobExpectation(id) {
  return request({
    url: `/api/expect/${id}`,
    method: 'delete'
  })
}

// 查看求职期望列表
export function getJobExpectationList(params) {
  return request({
    url: '/api/expect/list',
    method: 'get',
    params
  })
}

// 添加求职期望
export function addJobExpectation(data) {
  return request({
    url: '/api/expect/save',
    method: 'post',
    data
  })
}

// 修改求职期望
export function updateJobExpectation(data) {
  return request({
    url: '/api/expect/update',
    method: 'post',
    data
  })
}

// 获取职位信息（用于聊天页顶部标签）
export function getJobInfo(params) {
  return request({
    url: '/api/position/getJobInfo',
    method: 'get',
    params
  })
}
